// Module
var code = "<div class=\"task-comments\"> <div class=\"row\" style=\"padding:0;margin:0;width:100%\"> <div class=\"twelve\" ng-if=\"vm.id\" id=\"{{vm.id}}\"> </div> </div> </div>";
// Exports
module.exports = code;